import { ThemeUIStyleObject } from 'theme-ui';

// Custom progress bar container styles
export const progressBarContainerStyles: ThemeUIStyleObject = {
  bg: 'neutral/200', // #F0F3F6 as per Figma
  borderRadius: '5rem', // As per Figma
  height: '1rem', // 16px
  width: '100%',
  overflow: 'hidden',
  display: 'flex',
  alignItems: 'stretch',
};

// Interactive progress bar container styles
export const interactiveProgressBarContainerStyles = (
  width: string,
  disabled: boolean
): ThemeUIStyleObject => ({
  ...progressBarContainerStyles,
  width,
  cursor: disabled ? 'not-allowed' : 'pointer',
  opacity: disabled ? 0.6 : 1,
  userSelect: 'none' as const,
});

// Progress bar fill styles - returns ThemeUIStyleObject with dynamic color
export const progressBarFillStyles = (
  color: string,
  percentage: number
): ThemeUIStyleObject => ({
  bg: color, // Use Zenith color token directly
  height: '100%',
  width: `${percentage}%`,
  transition: 'width 0.3s ease', // Smooth animation
});
